import { Grid, TextField } from "@mui/material";
import { useCustomModel } from "components/context/CustomProvider";
import SectionGrid from "components/ui/atoms/SectionGrid";
import { useController } from "react-hook-form";

const CustomObjectField = ({ field, control }) => {
  const { field: fieldProps, fieldState } = useController({
    control,
    name: field.name,
  });

  if (!field.subModel) {
    console.warn(
      `Field ${field.name} is missing subModel, which is required for object fields.`,
    );
  }
  const subModel = useCustomModel(field.subModel);

  if (field.disabled) {
    return (
      <TextField
        disabled
        label={field.label}
        value={fieldProps.value?._title || ""}
      />
    );
  }

  if (subModel && subModel.formComponent)
    return (
      <subModel.formComponent
        field={field}
        control={control}
        value={fieldProps.value}
      />
    );
  return (
    <Grid container spacing={1} alignItems="center" sx={{ display: "block" }}>
      <SectionGrid
        title={field.label}
        sx={{
          display: field.hidden ? "none" : "inherit",
          textAlign: "justify",
          backgroundColor: "#f5f5f5",
          padding: 1,
        }}
      >
        XXXXXX
      </SectionGrid>
    </Grid>
  );
};

export default CustomObjectField;
